module.exports = __webpack_public_path__ + "4d310cff2dd5e5b1ce06726ecdb976a9.jpg";